// Photos for the canvas. They're loaded with CORS so the finished post can be
// exported (a canvas that draws a non-CORS image can't be saved). S3 and
// Unsplash both allow it; a copy the browser cached without CORS headers is
// avoided with a query of our own.
const cache = new Map()
const drawn = []
const KEEP_DRAWN = 60

const corsUrl = (src) => {
  if (!/^https?:/i.test(src)) return src
  if (/images\.unsplash\.com/.test(src)) return src
  return `${src}${src.includes('?') ? '&' : '?'}beu-canvas=1`
}

// Unsplash photos come at the size needed, not the 5000px original
const sized = (src, width) => {
  if (!/^https:\/\/images\.unsplash\.com\//.test(src)) return src
  const [base, query = ''] = src.split('?')
  const focal = query.split('&').filter(p => /^fp-(x|y|z)=[\d.]+$/.test(p))
  return `${base}?w=${width}&q=80&fm=jpg${focal.length ? `&fit=crop&crop=focalpoint&${focal.join('&')}` : ''}`
}

// small: for thumbnails (previews on the Social page and in the pickers)
export const loadImage = (src, { small = false } = {}) => {
  if (!src) return Promise.resolve(null)
  const key = `${small ? 's' : 'l'}|${src}`
  if (cache.has(key)) return cache.get(key)
  const p = new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.decoding = 'async'
    img.onload = () => resolve(img)
    img.onerror = () => resolve(null)
    img.src = corsUrl(sized(src, small ? 480 : 1400))
  })
  cache.set(key, p)
  // A seasonal design is a new picture with every change to its words: keep
  // only the latest of those
  if (/^data:image\/svg/.test(src)) {
    drawn.push(key)
    if (drawn.length > KEEP_DRAWN) cache.delete(drawn.shift())
  }
  return p
}

// Every photo a post needs, loaded; returns { src: HTMLImageElement|null }
export const loadImages = async (srcs, opts) => {
  const list = Array.from(new Set((srcs || []).filter(Boolean)))
  const imgs = await Promise.all(list.map(s => loadImage(s, opts)))
  const out = {}
  list.forEach((s, i) => { out[s] = imgs[i] })
  return out
}
